export default "__VITE_ASSET__4fbc47a8__"